import LabelValueRow from './LabelValueRow';

export default LabelValueRow;
